import { OpportunityUserView } from '@api-proxies';
import { CustomCellActionsComponent } from '@app/components/shared/grids/custom-cell-actions/custom-cell-actions.component';
import { ColDef, ICellRendererParams } from 'ag-grid-enterprise';

export const OPPORTUNITY_USERS_GRID_COLUMNS: ColDef[] = [
    {
        colId: 'userFullName',
        field: 'userFullName',
        headerName: 'Name',
        cellDataType: 'text',
        sortable: true,
        lockVisible: true
    },
    {
        colId: 'userRoleDescriptions',
        field: 'userRoleDescriptions',
        headerName: 'Opportunity Roles',
        cellDataType: 'text',
        sortable: true,
        lockVisible: true
    },
    {
        colId: 'email',
        field: 'email',
        headerName: 'Details',
        cellDataType: 'text',
        sortable: true,
        lockVisible: true
    },
    {
        colId: 'commissionPercentage',
        field: 'commissionPercentage',
        headerName: 'Percentage of Commission',
        cellDataType: 'number',
        sortable: true,
        cellRenderer: (params: ICellRendererParams<OpportunityUserView>) => {
            return params.value ? `${params.value}%` : '';
        },
        lockVisible: true
    },
    {
        colId: 'actions',
        headerName: '',
        maxWidth: 80,
        sortable: false,
        filter: false,
        resizable: false,
        suppressHeaderMenuButton: true,
        suppressSizeToFit: true,
        cellRenderer: CustomCellActionsComponent,
        cellClass: 'action-cell',
        lockVisible: true
    }
];
